import React from 'react';
import ContainerPage from '../../../../components/ContainerPage';
import { Button } from '../../../../components';
import { Page, useExecutiveCheckupRouter } from '../../router/context';

import * as S from './styles';
import HeadTitle from '../../../../components/HeadTitle';
import WarningIcon from '../../../../components/WarningIcon';
import { CallCenterModal } from '../../components/CallCenterModal';

const ComplementaryExams = (state: any) => {
  const router = useExecutiveCheckupRouter();
  const [isOpenCallCenterModal, setIsOpenCallCenterModal] = React.useState(false);

  const navigateNextPage = () => router.navigate(Page.INFO, { ...state });

  const toggleCallCenterModal = () => setIsOpenCallCenterModal(!isOpenCallCenterModal);

  return (
    <ContainerPage
      childrenFooterTransparent={
        <>
          <Button title="Sim" onClick={toggleCallCenterModal} />
          <Button tertiary title="Não" onClick={navigateNextPage} />
        </>
      }
    >
      <HeadTitle title="Exames complementares" goBack={router.goBack} />
      <S.Container>
        <WarningIcon />
        <h3 className="title">Facilite o seu check-up</h3>

        <p className="info">
          Se você possui pedidos de exames que ainda precisam ser realizados, é possível agendá-los para o mesmo dia do
          seu atendimento.
        </p>
        <p className="info">Deseja agendar esses exames agora?</p>
      </S.Container>
      <CallCenterModal visible={isOpenCallCenterModal} onClose={toggleCallCenterModal} />
    </ContainerPage>
  );
};

export default ComplementaryExams;
